import { Badge, Card, CardContent, CardHeader, CardTitle, Spinner, buttonClass } from '@1k5-tech-es/grado-react';
import { Download } from 'lucide-react';

import type { ReportableQuarter, ReportRun } from '../../api/types';
import { ErrorBlock } from '../../components/ui';
import { formatBytes, formatDateTime } from '../../lib/format';
import { quarterEndingAt, quarterLabel, samePeriod } from './quarters';

const runEnd = (run: ReportRun) => ({ year: run.periodEndYear, month: run.periodEndMonth });

/** Batches generated before, newest first; the ones of the selected quarter stand out. */
export function RunHistory({
  runs,
  error,
  selected,
}: {
  runs: ReportRun[] | undefined;
  error: unknown;
  selected: ReportableQuarter | null;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle as="h2">Generados anteriormente</CardTitle>
      </CardHeader>
      <CardContent>
        {error ? (
          <ErrorBlock error={error} />
        ) : !runs ? (
          <div className="py-4">
            <Spinner />
          </div>
        ) : runs.length === 0 ? (
          <p className="text-sm text-muted-foreground">Aún no se ha generado ningún lote de informes.</p>
        ) : (
          <ul className="space-y-1.5">
            {runs.map((run) => {
              const current = selected !== null && samePeriod(runEnd(run), selected.end);
              return (
                <li
                  key={run.id}
                  className={`flex items-center justify-between gap-3 rounded-lg px-3 py-2.5 ${
                    current ? 'bg-primary-subtle ring-1 ring-primary-border' : 'hover:bg-muted'
                  }`}
                >
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2 text-sm font-semibold">
                      {quarterLabel(quarterEndingAt(runEnd(run)))}
                      {current && <Badge tone="brand">Este trimestre</Badge>}
                    </div>
                    <div className="truncate text-xs text-muted-foreground">
                      {run.reportCount} informes · {formatBytes(run.fileSize)} · {formatDateTime(run.createdAt)}
                      {run.createdBy && ` · ${run.createdBy}`}
                    </div>
                    {run.skippedAdvisors.length > 0 && (
                      <div className="text-xs text-warning-text">Sin datos: {run.skippedAdvisors.join(', ')}</div>
                    )}
                  </div>
                  <a
                    className={`${buttonClass({ variant: 'secondary', size: 'sm' })} shrink-0`}
                    href={`/api/reports/${run.id}/download`}
                    title={run.fileName}
                  >
                    <Download aria-hidden />
                    Descargar
                  </a>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
